import { ROW_READER_MODE_CONFIG } from '../constants';
import { ERowReaderMode } from '../types';

export const readNumeric = (metric: Record<string, unknown> | undefined, key: string): number => {
  const raw = metric?.[key];
  return typeof raw === 'number' ? raw : 0;
};

export const resolveRowKey = (
  key: string,
  mode: ERowReaderMode = ERowReaderMode.DEFAULT,
  groupDimension?: string,
): string => {
  const { prefix, suffix } = ROW_READER_MODE_CONFIG[mode];
  if (mode === ERowReaderMode.GROUP_TOTALS && groupDimension) {
    return `${prefix}${key}___${groupDimension}${suffix}`;
  }
  return `${prefix}${key}${suffix}`;
};

export const createRawRowReader =
  (
    row: Record<string, unknown>,
    mode: ERowReaderMode = ERowReaderMode.DEFAULT,
    groupDimension?: string,
  ) =>
  (key: string): unknown =>
    row[resolveRowKey(key, mode, groupDimension)];

export const createNumericRowReader =
  (
    row: Record<string, unknown>,
    mode: ERowReaderMode = ERowReaderMode.DEFAULT,
    groupDimension?: string,
  ) =>
  (key: string): number => {
    const v = row[resolveRowKey(key, mode, groupDimension)];
    if (typeof v === 'number') return v;
    if (typeof v === 'string') {
      const n = parseFloat(v);
      return isNaN(n) ? 0 : n;
    }
    return 0;
  };
